"use client"

import { Badge } from "@/components/ui/badge"
import { CANDIDATE_CATEGORIES } from "@/utils/applicantsTable/constants"

interface CategorySummaryProps {
  categoryCounts: Record<string, number>
  categoryFilter: string | null
  onCategoryFilterChange: (category: string | null) => void
}

export function CategorySummary({ categoryCounts, categoryFilter, onCategoryFilterChange }: CategorySummaryProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      {Object.entries(CANDIDATE_CATEGORIES).map(([category, info]) => (
        <div
          key={category}
          className={`p-4 rounded-lg border border-gray-200 shadow-sm bg-white cursor-pointer transition-all duration-200 hover:shadow-md ${
            categoryFilter === category ? "ring-2 ring-gray-800" : ""
          }`}
          onClick={() => onCategoryFilterChange(categoryFilter === category ? null : category)}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              {info.icon}
              <span className="font-medium text-gray-800">{category}</span>
            </div>
            <Badge className={info.badge}>{categoryCounts[category] || 0}</Badge>
          </div>
          <p className="text-sm text-gray-600 mt-1">{info.description}</p>
        </div>
      ))}
    </div>
  )
}
